const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager report component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUserJourneys', ['Application', 'UserJourneys', function (Application, UserJourneys) {
  return {
    restrict: 'E',
    scope: {
      manager: '=',
      singleUser: '=',
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-user-journeys.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.activeJourneys = false;
      self.userJourneysData = [];
      self.load = async function () {
        const now = new Date().toISOString();
        const query = {
          page: 0,
          perPage: 10,
          query: {
            user: $scope.singleUser
          }
        };
        const userJourneys = await UserJourneys.list(query).$promise;
        for (const uj of userJourneys) {
          let percentCompleted = 0;
          if (uj.satisfiable_entities.length > 0) {
            percentCompleted = (uj.satisfiable_entities.filter(entity => entity.satisfied_status === true).length / uj.journey.satisfiable_entities.length * 100).toFixed(0);
          }
          const durationEndDate = uj.satisfied_date ? uj.satisfied_date : now;
          self.userJourneysData.push({
            id: uj._id,
            journeyId: uj.journey._id,
            title: uj.journey.title,
            percentCompleted,
            duration: moment(durationEndDate).diff(moment(uj.createdAt), 'days') + ' days', // may be calculated using updatedAt/dateCompleted and createdAt fields instead
            dateSatisfied: uj.satisfied_date, 
            createdAt: uj.createdAt,
            updatedAt: uj.updatedAt,
          });
        }
        self.loading = true;

        if (self.userJourneysData.length) {
          self.activeRegistrations = true;
        }
        if (!self.userJourneysData.length && self.activeJourneys) {
          self.paginate.emptyPage = true;
          self.paginate.page--;
        }
        self.loading = false;
        $scope.$apply();
      }

      // Handle pagination
      self.paginate = {
        perPage: 10,
        page: 0,
        emptyPage: false,
        nextPage: function () {
          this.page++;
          self.load();
        },
        previousPage: function () {
          if (this.emptyPage) {
            this.emptyPage = false;
          }
          this.page--;
          self.load();
        }
      }

      self.viewJourney = (journeyId) => {
        if (!journeyId) {
          return;
        }
        Application.navigation.goTo(`/view/journey/${journeyId}`);
      }
      
      self.goToEditJourney = (journeyId) => {
        if (!journeyId) {
          return;
        }
        Application.navigation.goTo(`/edit/journeys/${journeyId}`);
      }

      // Initialize component
      if ($scope.singleUser) {
        self.load();
      }

    }],
    controllerAs: 'userJourneys'
  };
}]);